import { cardConnectFrameDialogService } from './cardConnectFrameDialogForm';

var cardConnectIframeDialogMembershipBillingInformation = {

    cardConnectFrameDialogService: null,

    init: function() {
        this.cardConnectFrameDialogService = new cardConnectFrameDialogService();
    },

    openDialog: function(cardConnectIframeDialogOptions, callback) {
        this.init();
        this.cardConnectFrameDialogService.open(
            function(form, data) {
                callback(data);
            },
            {
                dialogOptions: {
                    title: '<b>Enter Credit/Debit Card to store on file</b>',
                    caProUI: true,
                    staticForm: false,
                },
                cardConnectIframeDialogOptions: cardConnectIframeDialogOptions
            }
        );
    },
};

export default cardConnectIframeDialogMembershipBillingInformation;
